import { Components, Theme } from '@mui/material';

// Define dark theme specific MuiFormLabel styles
export const muiFormLabel: Theme['components'] = {
  MuiFormLabel: {
    styleOverrides: {
      root: {
        color: '#B0BEC5', // Light gray for better readability in dark theme
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.4375,
        letterSpacing: '0.00938em',

        '&.Mui-focused': {
          color: '#90CAF9', // Light blue when focused
        },

        '&.Mui-error': {
          color: '#F48FB1', // Light pink for errors in dark theme
        },

        '&.Mui-disabled': {
          color: '#555555', // Darker gray for disabled state
        },
      },

      asterisk: {
        color: '#F48FB1', // Light pink for required asterisk

        '&.Mui-error': {
          color: '#F48FB1',
        },
      },
    },
  } as Components['MuiFormLabel'],
};
